const SHOES_SIZES = [
  {
    brand: "Y-3",
    sizes: [
      { us: 4, usWomen: 5, cm: 22.1, uk: 3.5, eu: 36 },
      { us: 4.5, usWomen: 5.5, cm: 22.5, uk: 4, eu: "36 2/3" },
      { us: 5, usWomen: 6, cm: 22.9, uk: 4.5, eu: "37 1/3" },
      { us: 5.5, usWomen: 6.5, cm: 23.3, uk: 5, eu: 38 },
      { us: 6, usWomen: 7, cm: 23.8, uk: 5.5, eu: "38 2/3" },
      { us: 6.5, usWomen: 7.5, cm: 24.2, uk: 6, eu: "39 1/3" },
      { us: 7, usWomen: 8, cm: 24.6, uk: 6.5, eu: 40 },
      { us: 7.5, usWomen: 8.5, cm: 25, uk: 7, eu: "40 2/3" },
      { us: 8, usWomen: 9, cm: 25.5, uk: 7.5, eu: "41 1/3" },
      { us: 8.5, usWomen: 9.5, cm: 25.9, uk: 8, eu: 42 },
      { us: 9, usWomen: 10, cm: 26.3, uk: 8.5, eu: "42 2/3" },
      { us: 9.5, usWomen: 10.5, cm: 26.7, uk: 9, eu: "43 1/3" },
      { us: 10, usWomen: 11, cm: 27.1, uk: 9.5, eu: 44 },
      { us: 10.5, usWomen: 11.5, cm: 27.6, uk: 10, eu: "44 2/3" },
      { us: 11, usWomen: 12, cm: 28, uk: 10.5, eu: "45 1/3" },
      { us: 11.5, usWomen: 12.5, cm: 28.4, uk: 11, eu: 46 },
      { us: 12, usWomen: 13, cm: 28.8, uk: 11.5, eu: "46 2/3" },
      { us: 13, usWomen: 14, cm: 29.7, uk: 12.5, eu: 48 },
      { us: 14, usWomen: 15, cm: 30.5, uk: 13.5, eu: "49 1/3" },
    ],
  },
  {
    brand: "Reebok",
    sizes: [
      { us: 5, uk: 4, eu: 36, cm: 23.5 },
      { us: 5.5, uk: 4.5, eu: 36.5, cm: 23.6 },
      { us: 6, uk: 5, eu: 37.5, cm: 24 },
      { us: 6.5, uk: 5.5, eu: 38.5, cm: 24.5 },
      { us: 7, uk: 6, eu: 39, cm: 25 },
      { us: 7.5, uk: 6.5, eu: 40, cm: 25.5 },
      { us: 8, uk: 7, eu: 40.5, cm: 26 },
      { us: 8.5, uk: 7.5, eu: 41, cm: 26.5 },
      { us: 9, uk: 8, eu: 42, cm: 27 },
      { us: 9.5, uk: 8.5, eu: 42.5, cm: 27.5 },
      { us: 10, uk: 9, eu: 43, cm: 28 },
      { us: 10.5, uk: 9.5, eu: 44, cm: 28.5 },
      { us: 11, uk: 10, eu: 44.5, cm: 29 },
      { us: 11.5, uk: 10.5, eu: 45, cm: 29.5 },
      { us: 12, uk: 11, eu: 45.5, cm: 30 },
      { us: 13, uk: 12, eu: 47, cm: 31 },
      { us: 14, uk: 13, eu: 48.5, cm: 32 },
    ],
  },
  {
    brand: "Nike",
    sizes: [
      { us: 2, usWomen: 3.5, uk: 1.5, eu: 33.5, cm: 20.8, inches: 8.2 },
      { us: 2.5, usWomen: 4, uk: 1.5, eu: 34.5, cm: 21.2, inches: 8.3 },
      { us: 3, usWomen: 4.5, uk: 2, eu: 35, cm: 21.6, inches: 8.5 },
      { us: 3.5, usWomen: 5, uk: 2.5, eu: 35.5, cm: 22, inches: 8.7 },
      { us: 4, usWomen: 5.5, uk: 3, eu: 36, cm: 22.5, inches: 8.85 },
      { us: 4.5, usWomen: 6, uk: 3.5, eu: 36.5, cm: 23, inches: 9.05 },
      { us: 5, usWomen: 6.5, uk: 4, eu: 37.5, cm: 23.5, inches: 9.25 },
      { us: 5.5, usWomen: 7, uk: 4.5, eu: 38, cm: 24, inches: 9.44 },
      { us: 6, usWomen: 7.5, uk: 5, eu: 38.5, cm: 24.5, inches: 9.64 },
      { us: 6.5, usWomen: 8, uk: 5.5, eu: 39, cm: 25, inches: 9.84 },
      { us: 7, usWomen: 8.5, uk: 6, eu: 40, cm: 25.5, inches: 10.03 },
      { us: 7.5, usWomen: 9, uk: 6.5, eu: 40.5, cm: 26, inches: 10.23 },
      { us: 8, usWomen: 9.5, uk: 7, eu: 41, cm: 26.5, inches: 10.43 },
      { us: 8.5, usWomen: 10, uk: 7.5, eu: 42, cm: 27, inches: 10.62 },
      { us: 9, usWomen: 10.5, uk: 8, eu: 42.5, cm: 27.5, inches: 10.82 },
      { us: 9.5, usWomen: 11, uk: 8.5, eu: 43, cm: 28, inches: 11.02 },
      { us: 10, usWomen: 11.5, uk: 9, eu: 44, cm: 28.5, inches: 11.22 },
      { us: 10.5, usWomen: 12, uk: 9.5, eu: 44.5, cm: 29, inches: 11.41 },
      { us: 11, usWomen: 12.5, uk: 10, eu: 45, cm: 29.5, inches: 11.61 },
      { us: 11.5, usWomen: 13, uk: 10.5, eu: 45.5, cm: 30, inches: 11.81 },
      { us: 12, usWomen: 13.5, uk: 11, eu: 46, cm: 30.5, inches: 12 },
      { us: 12.5, usWomen: 14, uk: 11.5, eu: 47, cm: 31, inches: 12.2 },
      { us: 13, usWomen: 14.5, uk: 12, eu: 47.5, cm: 31.5, inches: 12.4 },
      { us: 14, usWomen: 15.5, uk: 13, eu: 48.5, cm: 32.5, inches: 12.79 },
      { us: 15, usWomen: 16.5, uk: 14, eu: 49.5, cm: 33.5, inches: 13.18 },
      // Kids (C = toddler, Y = youth)
      { usKids: "4C", uk: 3.5, eu: 19.5, cm: 10, inches: 3.94 },
      { usKids: "5C", uk: 4.5, eu: 21, cm: 11, inches: 4.33 },
      { usKids: "6C", uk: 5.5, eu: 22, cm: 12, inches: 4.72 },
      { usKids: "7C", uk: 6.5, eu: 23.5, cm: 13, inches: 5.12 },
      { usKids: "8C", uk: 7.5, eu: 25, cm: 14, inches: 5.51 },
      { usKids: "9C", uk: 8.5, eu: 26, cm: 15, inches: 5.91 },
      { usKids: "10C", uk: 9.5, eu: 27, cm: 16, inches: 6.3 },
      { usKids: "11C", uk: 10.5, eu: 28, cm: 17, inches: 6.69 },
      { usKids: "12C", uk: 11.5, eu: 29.5, cm: 18, inches: 7.09 },
      { usKids: "13C", uk: 12.5, eu: 31, cm: 19, inches: 7.48 },
      { usKids: "1Y", uk: 13.5, eu: 32, cm: 20, inches: 7.87 },
      { usKids: "2Y", uk: 1.5, eu: 33.5, cm: 21, inches: 8.27 },
      { usKids: "3Y", uk: 2.5, eu: 35, cm: 22, inches: 8.66 },
      { usWomen: 5.5, usKids: "4Y", uk: 3.5, eu: 36, cm: 23, inches: 9.06 },
      { usWomen: 6.5, usKids: "5Y", uk: 4.5, eu: 37.5, cm: 23.5, inches: 9.25 },
      { usWomen: 7.5, usKids: "6Y", uk: 5.5, eu: 38.5, cm: 24, inches: 9.45 },
      { usWomen: 8.5, usKids: "7Y", uk: 6, eu: 40, cm: 25, inches: 9.84 },
    ],
  },
  {
    brand: "New Balance",
    sizes: [
      { us: 4, usWomen: 5.5, uk: 3.5, eu: 36, cm: 22 },
      { us: 4.5, usWomen: 6, uk: 4, eu: 37, cm: 22.5 },
      { us: 5, usWomen: 6.5, uk: 4.5, eu: 37.5, cm: 23 },
      { us: 5.5, usWomen: 7, uk: 5, eu: 38, cm: 23.5 },
      { us: 6, usWomen: 7.5, uk: 5.5, eu: 38.5, cm: 24 },
      { us: 6.5, usWomen: 8, uk: 6, eu: 39.5, cm: 24.5 },
      { us: 7, usWomen: 8.5, uk: 6.5, eu: 40, cm: 25 },
      { us: 7.5, usWomen: 9, uk: 7, eu: 40.5, cm: 25.5 },
      { us: 8, usWomen: 9.5, uk: 7.5, eu: 41.5, cm: 26 },
      { us: 8.5, usWomen: 10, uk: 8, eu: 42, cm: 26.5 },
      { us: 9, usWomen: 10.5, uk: 8.5, eu: 42.5, cm: 27 },
      { us: 9.5, usWomen: 11, uk: 9, eu: 43, cm: 27.5 },
      { us: 10, usWomen: 11.5, uk: 9.5, eu: 44, cm: 28 },
      { us: 10.5, usWomen: 12, uk: 10, eu: 44.5, cm: 28.5 },
      { us: 11, usWomen: 12.5, uk: 10.5, eu: 45, cm: 29 },
      { us: 12, usWomen: 13.5, uk: 11.5, eu: 46.5, cm: 30 },
      { us: 13, usWomen: 15, uk: 12.5, eu: 47.5, cm: 31 },
    ],
  },
  {
    brand: "Jordan",
    sizes: [
      { us: 4, usWomen: 5.5, uk: 3, eu: 36, cm: 22.5, inches: 8.85 },
      { us: 4.5, usWomen: 6, uk: 3.5, eu: 36.5, cm: 23, inches: 9.05 },
      { us: 5, usWomen: 6.5, uk: 4, eu: 37.5, cm: 23.5, inches: 9.25 },
      { us: 5.5, usWomen: 7, uk: 4.5, eu: 38, cm: 24, inches: 9.44 },
      { us: 6, usWomen: 7.5, uk: 5, eu: 38.5, cm: 24.5, inches: 9.64 },
      { us: 6.5, usWomen: 8, uk: 5.5, eu: 39, cm: 25, inches: 9.84 },
      { us: 7, usWomen: 8.5, uk: 6, eu: 40, cm: 25.5, inches: 10.03 },
      { us: 7.5, usWomen: 9, uk: 6.5, eu: 40.5, cm: 26, inches: 10.23 },
      { us: 8, usWomen: 9.5, uk: 7, eu: 41, cm: 26.5, inches: 10.43 },
      { us: 8.5, usWomen: 10, uk: 7.5, eu: 42, cm: 27, inches: 10.62 },
      { us: 9, usWomen: 10.5, uk: 8, eu: 42.5, cm: 27.5, inches: 10.82 },
      { us: 9.5, usWomen: 11, uk: 8.5, eu: 43, cm: 28, inches: 11.02 },
      { us: 10, usWomen: 11.5, uk: 9, eu: 44, cm: 28.5, inches: 11.22 },
      { us: 10.5, usWomen: 12, uk: 9.5, eu: 44.5, cm: 29, inches: 11.41 },
      { us: 11, usWomen: 12.5, uk: 10, eu: 45, cm: 29.5, inches: 11.61 },
      { us: 11.5, usWomen: 13, uk: 10.5, eu: 45.5, cm: 30, inches: 11.81 },
      { us: 12, usWomen: 13.5, uk: 11, eu: 46, cm: 30.5, inches: 12 },
      { us: 12.5, usWomen: 14, uk: 11.5, eu: 47, cm: 31, inches: 12.2 },
      { us: 13, usWomen: 14.5, uk: 12, eu: 47.5, cm: 31.5, inches: 12.4 },
      { us: 14, usWomen: 15.5, uk: 13, eu: 48.5, cm: 32.5, inches: 12.79 },
      { us: 15, usWomen: 16.5, uk: 14, eu: 49.5, cm: 33.5, inches: 13.18 },
      // Kids (C = toddler, Y = youth)
      { usKids: "4C", uk: 3.5, eu: 19.5, cm: 10, inches: 3.94 },
      { usKids: "5C", uk: 4.5, eu: 21, cm: 11, inches: 4.33 },
      { usKids: "6C", uk: 5.5, eu: 22, cm: 12, inches: 4.72 },
      { usKids: "7C", uk: 6.5, eu: 23.5, cm: 13, inches: 5.12 },
      { usKids: "8C", uk: 7.5, eu: 25, cm: 14, inches: 5.51 },
      { usKids: "9C", uk: 8.5, eu: 26, cm: 15, inches: 5.91 },
      { usKids: "10C", uk: 9.5, eu: 27, cm: 16, inches: 6.3 },
      { usKids: "11C", uk: 10.5, eu: 28, cm: 17, inches: 6.69 },
      { usKids: "12C", uk: 11.5, eu: 29.5, cm: 18, inches: 7.09 },
      { usKids: "13C", uk: 12.5, eu: 31, cm: 19, inches: 7.48 },
      { usKids: "1Y", uk: 13.5, eu: 32, cm: 20, inches: 7.87 },
      { usKids: "2Y", uk: 1.5, eu: 33.5, cm: 21, inches: 8.27 },
      { usKids: "3Y", uk: 2.5, eu: 35, cm: 22, inches: 8.66 },
      { usWomen: 5.5, usKids: "4Y", uk: 3.5, eu: 36, cm: 23, inches: 9.06 },
      { usWomen: 6.5, usKids: "5Y", uk: 4.5, eu: 37.5, cm: 23.5, inches: 9.25 },
      { usWomen: 7.5, usKids: "6Y", uk: 5.5, eu: 38.5, cm: 24, inches: 9.45 },
      { usWomen: 8.5, usKids: "7Y", uk: 6, eu: 40, cm: 25, inches: 9.84 },
    ],
  },
  {
    brand: "Converse",
    sizes: [
      { us: 3, usWomen: 5, uk: 3, eu: 35, cm: 22 },
      { us: 4, usWomen: 6, uk: 4, eu: 36.5, cm: 23 },
      { us: 5, usWomen: 7, uk: 5, eu: 37.5, cm: 24 },
      { us: 6, usWomen: 8, uk: 6, eu: 39, cm: 25 },
      { us: 7, usWomen: 9, uk: 7, eu: 40, cm: 26 },
      { us: 8, usWomen: 10, uk: 8, eu: 41.5, cm: 27 },
      { us: 9, usWomen: 11, uk: 9, eu: 42.5, cm: 28 },
      { us: 10, usWomen: 12, uk: 10, eu: 44, cm: 29 },
      { us: 11, usWomen: 13, uk: 11, eu: 45, cm: 30 },
      { us: 12, usWomen: 14, uk: 12, eu: 46.5, cm: 32 },
      { us: 13, usWomen: 15, uk: 13, eu: 47.5, cm: 33 },
      // Kids (C = toddler, Y = youth)
      { usKids: "4C", uk: 4, eu: 20, cm: 11.8 },
      { usKids: "5C", uk: 5, eu: 21, cm: 12.7 },
      { usKids: "6C", uk: 6.5, eu: 22, cm: 13.5 },
      { usKids: "7C", uk: 7, eu: 23, cm: 14.4 },
      { usKids: "8C", uk: 8, eu: 24, cm: 15.2 },
      { usKids: "9C", uk: 9, eu: 25, cm: 16 },
      { usKids: "10C", uk: 9.5, eu: 26, cm: 16.9 },
      { usKids: "11C", uk: 10.5, eu: 28, cm: 17.7 },
      { usKids: "12C", uk: 11.5, eu: 29, cm: 18.6 },
      { usKids: "13C", uk: 12.5, eu: 31, cm: 19.4 },
      { usKids: "1Y", uk: 13.5, eu: 32, cm: 20.3 },
      { usKids: "2Y", uk: 1.5, eu: 33.5, cm: 21.1 },
      { usKids: "3Y", uk: 2.5, eu: 35, cm: 22 },
    ],
  },
  {
    brand: "Clarks Originals",
    sizes: [
      { us: 5, uk: 4, clarksEUR: 37, eu: null, cm: null },
      { us: 6, uk: 5, clarksEUR: 38, eu: 38, cm: 23.7 },
      { us: 7, uk: 6, clarksEUR: 39.5, eu: 39, cm: 24.6 },
      { us: 8, uk: 7, clarksEUR: 41, eu: 41, cm: 25.4 },
      { us: 9, uk: 8, clarksEUR: 42, eu: 42, cm: 26.3 },
      { us: 10, uk: 9, clarksEUR: 43, eu: 43, cm: 27.2 },
      { us: 11, uk: 10, clarksEUR: 44.5, eu: 45, cm: 28.0 },
      { us: 12, uk: 11, clarksEUR: 46, eu: 46, cm: 28.9 },
      { us: 13, uk: 12, clarksEUR: 47, eu: 47, cm: 29.8 },
      { us: 14, uk: 13, clarksEUR: 48, eu: 48, cm: 30.6 },
    ],
  },
  {
    brand: "Adidas",
    sizes: [
      { us: 4, usWomen: 5, cm: 22.1, uk: 3.5, eu: 36 },
      { us: 4.5, usWomen: 5.5, cm: 22.5, uk: 4, eu: "36 2/3" },
      { us: 5, usWomen: 6, cm: 22.9, uk: 4.5, eu: "37 1/3" },
      { us: 5.5, usWomen: 6.5, cm: 23.3, uk: 5, eu: 38 },
      { us: 6, usWomen: 7, cm: 23.8, uk: 5.5, eu: "38 2/3" },
      { us: 6.5, usWomen: 7.5, cm: 24.2, uk: 6, eu: "39 1/3" },
      { us: 7, usWomen: 8, cm: 24.6, uk: 6.5, eu: 40 },
      { us: 7.5, usWomen: 8.5, cm: 25, uk: 7, eu: "40 2/3" },
      { us: 8, usWomen: 9, cm: 25.5, uk: 7.5, eu: "41 1/3" },
      { us: 8.5, usWomen: 9.5, cm: 25.9, uk: 8, eu: 42 },
      { us: 9, usWomen: 10, cm: 26.3, uk: 8.5, eu: "42 2/3" },
      { us: 9.5, usWomen: 10.5, cm: 26.7, uk: 9, eu: "43 1/3" },
      { us: 10, usWomen: 11, cm: 27.1, uk: 9.5, eu: 44 },
      { us: 10.5, usWomen: 11.5, cm: 27.6, uk: 10, eu: "44 2/3" },
      { us: 11, usWomen: 12, cm: 28, uk: 10.5, eu: "45 1/3" },
      { us: 11.5, usWomen: 12.5, cm: 28.4, uk: 11, eu: 46 },
      { us: 12, usWomen: 13, cm: 28.8, uk: 11.5, eu: "46 2/3" },
      { us: 13, usWomen: 14, cm: 29.7, uk: 12.5, eu: 48 },
      { us: 14, usWomen: 15, cm: 30.5, uk: 13.5, eu: "49 1/3 " },
    ],
  },
  {
    brand: "Asics",
    sizes: [
      { us: 4, usWomen: 5.5, uk: 3, eu: 35, cm: 22.5 },
      { us: 5, usWomen: 6.5, uk: 4, eu: 37.5, cm: 23.5 },
      { us: 5.5, usWomen: 7, uk: 4.5, eu: 38, cm: 24 },
      { us: 6, usWomen: 7.5, uk: 5, eu: 39, cm: 24.5 },
      { us: 6.5, usWomen: 8, uk: 5.5, eu: 39.5, cm: 25 },
      { us: 7, usWomen: 8.5, uk: 6, eu: 40, cm: 25.5 },
      { us: 7.5, usWomen: 9, uk: 6.5, eu: 40.5, cm: 25.75 },
      { us: 8, usWomen: 9.5, uk: 7, eu: 41.5, cm: 26 },
      { us: 8.5, usWomen: 10, uk: 7.5, eu: 42, cm: 26.5 },
      { us: 9, usWomen: 10.5, uk: 8, eu: 42.5, cm: 27 },
      { us: 9.5, usWomen: 11, uk: 8.5, eu: 43.5, cm: 27.5 },
      { us: 10, usWomen: 11.5, uk: 9, eu: 44, cm: 28 },
      { us: 10.5, usWomen: 12, uk: 9.5, eu: 44.5, cm: 28.25 },
      { us: 11, usWomen: 12.5, uk: 10, eu: 45, cm: 28.5 },
      { us: 12, usWomen: 13.5, uk: 11, eu: 46.5, cm: 29.5 },
      { us: 13, usWomen: 14.5, uk: 12, eu: 48, cm: 30.5 },
    ],
  },
  {
    brand: "A Bathing Ape®",
    sizes: [
      { us: 4, usWomen: 5.5, uk: 3.5, eu: 36, cm: 23 },
      { us: 4.5, usWomen: 6, uk: 4, eu: 36.5, cm: 23.5 },
      { us: 5, usWomen: 6.5, uk: 4.5, eu: 37.5, cm: 23.5 },
      { us: 5.5, usWomen: 7, uk: 5, eu: 38, cm: 24 },
      { us: 6, usWomen: 7.5, uk: 5.5, eu: 38.5, cm: 24 },
      { us: 6.5, usWomen: 8, uk: 6, eu: 39, cm: 24.5 },
      { us: 7, usWomen: 8.5, uk: 6, eu: 40, cm: 25 },
      { us: 7.5, usWomen: 9, uk: 6.5, eu: 40.5, cm: 25.5 },
      { us: 8, usWomen: 9.5, uk: 7, eu: 41, cm: 26 },
      { us: 8.5, usWomen: 10, uk: 7.5, eu: 42, cm: 26.5 },
      { us: 9, usWomen: 10.5, uk: 8, eu: 42.5, cm: 27 },
      { us: 9.5, usWomen: 11, uk: 8.5, eu: 43, cm: 27.5 },
      { us: 10, usWomen: 11.5, uk: 9, eu: 44, cm: 28 },
      { us: 10.5, usWomen: 12, uk: 9.5, eu: 44.5, cm: 28.5 },
      { us: 11, usWomen: 12.5, uk: 10, eu: 45, cm: 29 },
      { us: 12, usWomen: 13, uk: 11, eu: 46, cm: 30 },
      { us: 13, usWomen: 13.5, uk: 12, eu: 47.5, cm: 31 },
    ],
  },
  {
    brand: "Crocs",
    sizes: [
      { us: 3, usWomen: 5, cm: 21 },
      { us: 4, usWomen: 6, cm: 22 },
      { us: 5, usWomen: 7, cm: 23 },
      { us: 6, usWomen: 8, cm: 24 },
      { us: 7, usWomen: 9, cm: 25 },
      { us: 8, usWomen: 10, cm: 26 },
      { us: 9, usWomen: 11, cm: 27 },
      { us: 10, usWomen: 12, cm: 28 },
      { us: 11, usWomen: 13, cm: 29 },
      { us: 12, usWomen: 14, cm: 30 },
      { us: 13, usWomen: 15, cm: 31 },
    ],
  },
];
